import themedefault from './themeDefault';
import rentalStep from './rentalstep';
import telford from './telford';

const themes = {
  themedefault,
  rentalStep,
  telford
};

export default themes;



// WEBPACK FOOTER //
// ./src/settings/themes/index.js